// import defaultSettings from "@/settings";

const title = "高铁开发集团招商运营管理系统";

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`;
  }
  return `${title}`;
}
